var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-info" },
    [
      _c(
        "el-form",
        {
          ref: "staffInfo",
          staticClass: "demo-ruleForm",
          attrs: { model: _vm.staffInfo, rules: _vm.staffRules }
        },
        [
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("姓名")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "name" } },
                  [
                    _c("el-input", {
                      staticClass: "width-2x",
                      attrs: { type: "text", "auto-complete": "off" },
                      model: {
                        value: _vm.staffInfo.name,
                        callback: function($$v) {
                          _vm.$set(_vm.staffInfo, "name", $$v)
                        },
                        expression: "staffInfo.name"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("员工编号")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "no" } },
                  [
                    _c("el-input", {
                      staticClass: "width-2x",
                      attrs: {
                        disabled: _vm.noDisabled,
                        type: "text",
                        "auto-complete": "off"
                      },
                      model: {
                        value: _vm.staffInfo.no,
                        callback: function($$v) {
                          _vm.$set(_vm.staffInfo, "no", $$v)
                        },
                        expression: "staffInfo.no"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.id == null
            ? _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", { staticClass: "required" }, [_vm._v("用户手机")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "phoneNo" } },
                      [
                        _c("el-input", {
                          staticClass: "width-2x",
                          attrs: { type: "text", "auto-complete": "off" },
                          model: {
                            value: _vm.staffInfo.phoneNo,
                            callback: function($$v) {
                              _vm.$set(_vm.staffInfo, "phoneNo", $$v)
                            },
                            expression: "staffInfo.phoneNo"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("联系电话")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "contactTel" } },
                  [
                    _c("el-input", {
                      staticClass: "width-2x",
                      attrs: { type: "text", "auto-complete": "off" },
                      model: {
                        value: _vm.staffInfo.contactTel,
                        callback: function($$v) {
                          _vm.$set(_vm.staffInfo, "contactTel", $$v)
                        },
                        expression: "staffInfo.contactTel"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("联系邮箱")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "contactEmail" } },
                  [
                    _c("el-input", {
                      staticClass: "width-2x",
                      attrs: { type: "text", "auto-complete": "off" },
                      model: {
                        value: _vm.staffInfo.contactEmail,
                        callback: function($$v) {
                          _vm.$set(_vm.staffInfo, "contactEmail", $$v)
                        },
                        expression: "staffInfo.contactEmail"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-row spacing" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("员工头像")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c("swb-file-upload", {
                  attrs: {
                    fileFor: "solution",
                    fileGroup: "image-misc",
                    onBeforeUpload: _vm.onBeforeUpload,
                    onProgress: _vm.onProgress,
                    updateFileUuid: _vm.staffInfo.headUuid,
                    onDone: _vm.onUploadDone,
                    multipleFile: true
                  }
                }),
                _vm._v(" "),
                _vm.staffInfo.headUuid != null
                  ? _c("ul", { staticClass: "file-area clearfix" }, [
                      _c(
                        "li",
                        { staticClass: "file-item show-usage image deletable" },
                        [
                          _c("div", { staticClass: "file-content" }, [
                            _c("img", {
                              attrs: { src: _vm.staffInfo.fileBrowseUrl }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "delete-icon",
                              on: {
                                click: function($event) {
                                  _vm.removeUpload()
                                }
                              }
                            })
                          ])
                        ]
                      )
                    ])
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("描述")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "memo" } },
                  [
                    _c("el-input", {
                      staticClass: "width-2x",
                      attrs: {
                        type: "textarea",
                        rows: 2,
                        placeholder: "请输入内容"
                      },
                      model: {
                        value: _vm.staffInfo.memo,
                        callback: function($$v) {
                          _vm.$set(_vm.staffInfo, "memo", $$v)
                        },
                        expression: "staffInfo.memo"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eca02272", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eca02272","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/orgStruct/ServicerXStaffSave.vue
// module id = 1933
// module chunks = 1